import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectContractHistory, selectHistoryCase } from '../../redux/contract/selectors';
import {Columnas} from "../../Constantes/constantesColumnasTablas";
import Table from "../table/Table"
import { convertToLocalTime } from '../../commonFunctions/commonFunctions';
import CustomPagination from '../table/CustomPagination';
import { setHistoryCase } from '../../redux/contract/contractSlice';


function HistoricCases(){
    const historicCases = useSelector(selectContractHistory)
    const [casesInPage, setCasesInPage] = useState()
    const numElements = [5, 15, 20]
    const [pageSize, setPageSize] = useState(5)
    const [pageIndex, setPageIndex] = useState(1);
    const totalPages = historicCases? Math.ceil(historicCases.length / pageSize) : 0 ;
    const selectedCase = useSelector(selectHistoryCase);
    const dispatch = useDispatch();


    useEffect(()=>{
        if(historicCases){
           const withoutActive = historicCases.filter((e)=>!e.active || e.showCurrent)
           const endPosition= historicCases.length-1 > pageSize ? pageSize : historicCases.length-1
           const firstPage = withoutActive.slice(0, endPosition)
           
           setCasesInPage(firstPage);
           setPageIndex(1)
        }
    },[historicCases])

    function handlePageIndexChange(event, newIndex, newPageSize = pageSize){
        const withoutActive = historicCases.filter((e)=>!e.active || e.showCurrent)
        const startPosition = (newIndex-1)*newPageSize;
        const endPosition = startPosition + newPageSize;
        const currentPage =  withoutActive.slice(startPosition, endPosition)
        setCasesInPage(currentPage)
        setPageIndex(newIndex)
    }

    function handlePageSizeChange(newValue){
        setPageSize(newValue)
        handlePageIndexChange(null, 1, newValue)
    }

    function localizeDates(caselist){
        if(caselist){
         const localizedDates = caselist.map((e)=> {
            const local = {...e, creationDate: convertToLocalTime(e.creationDate), closeDate: convertToLocalTime(e.closeDate)};
            return local
          })
          return localizedDates}
    }

    function selectRow(e){
        dispatch(setHistoryCase(e.data))
        let grid = e.component;
        var rowKey = grid.getKeyByRowIndex(e.rowIndex);
        
        if (!e.isSelected){
            grid.selectRows([rowKey], false);
        }   
        else
            grid.deselectRows([rowKey]);
        
        const caseTitleDiv = document.getElementsByClassName("historic-case-title")[0]
        caseTitleDiv.scrollIntoView({ behavior: "smooth"})
    }

    return (
        <div style={{marginTop: "1rem", backgroundColor: "#EFF1F2"}}>
        <Table selectedHistoryCase={selectedCase?.caseId} type={"Historico"} handleRowClick={selectRow} enableSorting={false} datasource={localizeDates(casesInPage)} columnasTabla={Columnas()["Historico"]}/>
        <div style={{backgroundColor: "#EFF1F2"}}>
            <CustomPagination style={{position: "absolute"}} numElements={numElements} loading={historicCases?.length > 0 ? "succeeded" : "loading" } count={historicCases?.length} pageSize={pageSize} pageIndex={pageIndex} totalPages={totalPages} handlePageSizeChange={handlePageSizeChange} handlePageIndexChange={handlePageIndexChange} />
        </div>
        </div>
    )
}

export {HistoricCases}